module.exports = __webpack_public_path__ + "static/media/ms_excel.d910cedd.svg";